import { gql } from "@apollo/client";

export default gql`
  query getLocationCountries($params: GetCountriesInput!){
    getLocationCountries(params: $params){
        success
        data{
            docs{
                _id
                name
                iso2
                native
                translations{
                    kr
                    pt_BR
                    pt
                    nl
                    hr
                    fa
                    de
                    ja
                    it
                    cn
                    tr
                }
                emoji
                hasState
                hasProvince
                hasCity
            }
            totalDocs
            hasNextPage
            hasPrevPage
        }
        code
        message
    }
}
`
